export const defaultSettings = {
  teams: ["Team 1", "Team 2"],
  timer: 60,
  allowSkips: true,
  cardCount: 40,
  cardType: "base_hr",
  cardText: "Write your own cards. Only include 1 card per line.",
  isDrafting: false,
  playerCount: 4,
};

export const defaultScreen = 'home';
